import React, { useState, useEffect, useCallback } from 'react';

const ArticleRewardForm = ({ isOpen, onClose, onSuccess, formData, user, allRequests = [] }) => {
    const [availableArticles, setAvailableArticles] = useState([]);
    const [selectedArticles, setSelectedArticles] = useState([]);
    const [note, setNote] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const fetchAvailableArticles = useCallback(async () => {
        setIsLoading(true);
        try {
            const targetUserId = formData?.UserId || user?.Id;

            if (!targetUserId) {
                setAvailableArticles([]);
                setIsLoading(false);
                return;
            }

            const token = localStorage.getItem('accessToken');
            const res = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/scientificarticle?userId=${targetUserId}&isAdmin=false`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (res.ok) {
                const data = await res.json();
                const actualData = Array.isArray(data) ? data : (data.data || []);

                const usedArticleIds = [];
                allRequests.forEach(req => {
                    if (req.Id !== formData?.Id) {
                        try {
                            const ids = typeof req.ArticleIdsJson === 'string'
                                ? JSON.parse(req.ArticleIdsJson || '[]')
                                : (req.ArticleIds || []);
                            usedArticleIds.push(...ids.map(id => Number(id)));
                        } catch (e) {
                            console.error("Lỗi parse ArticleIdsJson:", e);
                        }
                    }
                });

                const filteredArticles = actualData.filter(article => !usedArticleIds.includes(Number(article.Id || article.id)));

                setAvailableArticles(filteredArticles);
            } else {
                console.error("Lỗi từ server:", res.status);
                setAvailableArticles([]);
            }
        } catch (error) {
            console.error("Lỗi khi tải danh sách bài báo:", error);
            setAvailableArticles([]);
        } finally {
            setIsLoading(false);
        }
    }, [formData?.UserId, formData?.Id, user?.Id, allRequests]);

    useEffect(() => {
        if (isOpen) {
            fetchAvailableArticles();

            if (formData && formData.Id !== 0) {
                setNote(formData.Note || '');
                try {
                    const parsedIds = formData.ArticleIdsJson ? JSON.parse(formData.ArticleIdsJson) : [];
                    setSelectedArticles(Array.isArray(parsedIds) ? parsedIds.map(id => Number(id)) : []);
                } catch (e) {
                    setSelectedArticles([]);
                }
            } else {
                setNote('');
                setSelectedArticles([]);
            }
        } else {
            setAvailableArticles([]);
            setSelectedArticles([]);
            setNote('');
        }
    }, [isOpen, formData, fetchAvailableArticles]);

    const handleCheckboxChange = (articleId) => {
        const numId = Number(articleId);
        if (selectedArticles.includes(numId)) {
            setSelectedArticles(selectedArticles.filter(id => id !== numId));
        } else {
            setSelectedArticles([...selectedArticles, numId]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (selectedArticles.length === 0) {
            alert("Vui lòng chọn ít nhất 1 bài báo để xét thưởng!");
            return;
        }

        const selectedData = availableArticles.filter(a => selectedArticles.includes(Number(a.Id || a.id)));
        const totalAmount = selectedData.reduce((sum, item) => sum + (Number(item.RewardAmount || item.rewardAmount) || 0), 0);

        const finalUserId = formData?.UserId || user?.Id;

        const payload = {
            Id: formData?.Id || 0,
            UserId: parseInt(finalUserId),
            Note: note,
            ArticleIds: selectedArticles,
            TotalAmount: totalAmount,
            ArticleCount: selectedArticles.length
        };

        try {
            const token = localStorage.getItem('accessToken');

            const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/articlereward`, {
                method: formData?.Id ? 'PUT' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            if (res.ok) {
                onSuccess();
            } else {
                const errorData = await res.json();
                alert(`Có lỗi xảy ra: ${errorData.message || 'Không thể lưu dữ liệu'}`);
            }
        } catch (error) {
            console.error("Lỗi lưu xét thưởng:", error);
            alert("Lỗi kết nối đến máy chủ!");
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxHeight: '95vh', overflowY: 'auto' }}>

                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '15px', lineHeight: '1.4' }}>
                        {formData?.Id ? 'Cập nhật xét thưởng công bố' : 'Thông tin xét thưởng công bố'}
                    </h3>
                    <button className="close-btn" onClick={onClose} style={{ fontSize: '26px', lineHeight: '1', display: 'flex', flexShrink: 0, marginTop: '-2px' }}>
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="rewardForm" onSubmit={handleSubmit}>

                        <div style={{ marginBottom: '15px' }}>
                            <h4 style={{ fontSize: '15px', color: '#333', fontWeight: 'bold', marginBottom: '10px' }}>
                                Chọn bài báo trong danh sách
                            </h4>
                        </div>

                        <div style={{ overflowX: 'auto', border: '1px solid #ddd', borderRadius: '4px', marginBottom: '10px', maxHeight: '300px', overflowY: 'auto' }}>
                            <table className="custom-table" style={{ margin: 0, border: 'none' }}>
                                <thead style={{ backgroundColor: '#f9f9f9', position: 'sticky', top: 0, zIndex: 1 }}>
                                    <tr>
                                        <th width="5%" style={{ textAlign: 'center' }}>Chọn</th>
                                        <th width="35%" style={{ color: '#003399' }}>Bài báo</th>
                                        <th width="13%" style={{ color: '#003399', textAlign: 'center' }}>Ngày công bố</th>
                                        <th width="15%" style={{ color: '#003399' }}>Tạp chí</th>
                                        <th width="10%" style={{ color: '#003399' }}>Loại tạp chí</th>
                                        <th width="11%" style={{ color: '#003399', textAlign: 'right' }}>Mức thưởng</th>
                                        <th width="11%" style={{ color: '#003399', textAlign: 'right' }}>Mức thưởng chính</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading ? (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: 'center', padding: '30px' }}>
                                                <i className="fa-solid fa-circle-notch fa-spin" style={{ color: '#3498db', marginRight: '8px' }}></i>
                                                Đang tải dữ liệu
                                            </td>
                                        </tr>
                                    ) : (!Array.isArray(availableArticles) || availableArticles.length === 0) ? (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
                                                Không có bài báo nào thỏa mãn điều kiện hoặc tất cả bài báo đã được xét thưởng
                                            </td>
                                        </tr>
                                    ) : (
                                        availableArticles.map((article) => (
                                            <tr key={article.Id}>
                                                <td style={{ textAlign: 'center' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedArticles.includes(Number(article.Id))}
                                                        onChange={() => handleCheckboxChange(article.Id)}
                                                        style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                                                    />
                                                </td>
                                                <td style={{ fontWeight: '500' }}>{article.Title || article.ArticleName || 'N/A'}</td>
                                                <td style={{ textAlign: 'center' }}>
                                                    {article.PublicationDate
                                                        ? (String(article.PublicationDate).includes('/')
                                                            ? article.PublicationDate
                                                            : new Date(article.PublicationDate).toLocaleDateString('vi-VN'))
                                                        : <span style={{ color: '#d32f2f' }}>N/A</span>}
                                                </td>
                                                <td>{article.JournalName || article.Journal || 'N/A'}</td>
                                                <td>{article.JournalType || 'Khác'}</td>
                                                <td style={{ textAlign: 'right' }}>{Number(article.RewardAmount || 0).toLocaleString()}</td>
                                                <td style={{ textAlign: 'right' }}>{Number(article.MainAuthorReward || 0).toLocaleString()}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <p style={{ fontStyle: 'italic', color: '#d32f2f', fontSize: '12px', marginTop: '10px', marginBottom: '20px' }}>
                            Chỉ hiển thị các bài báo đã gửi duyệt hoặc được duyệt và chưa đề xuất khen thưởng trước đó
                        </p>

                        <div className="form-group">
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ghi chú</label>
                            <textarea
                                name="Note"
                                className="form-input"
                                rows="3"
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                style={{ border: '1px solid #4caf50' }}
                            ></textarea>
                        </div>

                    </form>
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #eee', padding: '15px 25px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="rewardForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default ArticleRewardForm;